import { Component, computed, EventEmitter, inject, input, Output } from '@angular/core';

import { Course, CourseCertificateData } from 'src/index';
import { CoursesService } from 'src/index/services.index';

@Component({
    selector: 'meta-course-preview',
    templateUrl: './course-preview.component.html',
    styleUrls: ['./course-preview.component.css']
})
export class CoursePreviewComponent {
    coursesService = inject(CoursesService);

    $course = input<Course | undefined>(undefined, { alias: 'course' });
    $lowerHeight = input(false, { alias: 'lowerHeight' });
    $showProgress = input(false, { alias: 'showProgress' });
    $showStudents = input(false, { alias: 'showStudents' });
    $showSkills = input(false, { alias: 'showSkills' });
    $showImage = input(false, { alias: 'showImage' });
    $showDescription = input(false, { alias: 'showDescription' });
    $showContentTypeIcon = input(false, { alias: 'showContentTypeIcon' });
    $showStarIcon = input(false, { alias: 'showStarIcon' });
    $showLockIcon = input(false, { alias: 'showLockIcon' });

    $certificateData = input<CourseCertificateData | undefined>(undefined, { alias: 'certificateData' });

    $cover = computed(() => this.$course()?.image ?? '');
    $title = computed(() => this.$course()?.title ?? '');
    $duration = computed(() => this.$course()?.duration ?? '');
    $description = computed(() => this.$course()?.description ?? '');
    $skills = computed(() => this.$course()?.skills ?? []);
    $banned = computed(() => this.$course()?.banned ?? false);
    $students = computed(() => this.$course()?.students ?? 0);
    
    $progress = computed(() => (this.$course()?.progress || 0) * 1);
    $mandatoryProgress = computed(() => (this.$course()?.mandatoryProgress || 0) * 1);
    $mandatoryPercent = computed(() => (this.$course()?.mandatoryPercent || 0) * 1);

    $updated = computed(() => {
        const updatedAt = this.$course()?.updatedAt;
        const lastAccess = this.$course()?.lastAccess;

        if (updatedAt && lastAccess && typeof lastAccess === 'number' && typeof updatedAt === 'string') {
            const updatedDateObj = new Date(updatedAt);
            // updatedAt ha il timezone GMT+00, con il new Date viene adattatto al GMT+02, va corretto prima del confronto
            updatedDateObj.setHours(updatedDateObj.getHours() - 2);
            return updatedDateObj.getTime() > lastAccess;
        }

        return false;
    })

    $completed = computed(() => this.$progress() >= 100);
    $completedMandatory = computed(() => {
        const course = this.$course();
        if (course) {
            if (course.mandatoryProgress !== undefined) {
                return course.mandatoryProgress * 1 >= 100;
            }
            return (course.progress || 0) * 1 >= 100;
        }
        return false;
    });

    @Output() doClick = new EventEmitter<Event>();

    showCertificate() {
        this.coursesService.openCertificate(this.$course()?.certificateData);
    }
}
